<style scoped lang="scss">
  .wrap-login{
    background: url("../assets/images/login_bg.jpg") no-repeat;
    .login-main{
      height: 100vh;
      padding:40% 20% 0;
    }
    .logo{
      margin-bottom: 40px;
    }
    .forget{
      display: flex;
      justify-content: space-between;
      a{
        color: #014492;
      }
    }
    .login-method{
      position: absolute;
      top:40px;
      right:40px;
      display: flex;
      li{
        margin-left:20px;
        cursor: pointer;
        &.active{
          font-weight: bold;
          color: #014492;
        }
      }
    }
  }
@media screen and (max-width: 640px){
  .wrap-login{
    background: none!important;
  }
  .login-main {
    padding: 40% 10% 0 10%!important;
  }
    .el-col-offset-14{
    margin-left: 0!important;
  }
  .el-row{
    margin-left: 0!important;
    margin-right: 0!important;
  }
  .el-col-10{
    width: 100% !important;
  }
}
</style>
<template>
  <div class="wrap wrap-login">
    <el-row :gutter="40">
      <el-col :span="10" :offset="14">
        <div class="login-main">
          <ul class="login-method">
            <li v-for="(item, index) in methods" :key="index" :class="{active: currentMethod === index}" @click="currentMethod = index">{{item}}</li>
          </ul>
          <img src="@/assets/images/logo.png" class="logo">
          <el-form label-position="top" label-width="100px" ref="loginPasswordForm" :rules="loginPasswordRules" :model="loginPasswordForm" v-show="currentMethod === 0">
            <el-form-item label="帐号" prop="account">
              <el-input v-model="loginPasswordForm.account" placeholder="请输入邮箱/手机号"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="loginPasswordForm.password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loginPassword('loginPasswordForm')" style="width: 100%; margin-top: 30px;">登录</el-button>
            </el-form-item>
          </el-form>
          <el-form label-position="top" label-width="100px" ref="loginSmsForm" :rules="loginSmsRules" :model="loginSmsForm" v-show="currentMethod === 1">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="loginSmsForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="captcha">
              <el-input v-model="loginSmsForm.captcha" placeholder="请输入验证码">
                <span slot="suffix" class="mr10 text-primary pointer" @click="getCode" v-if="timesCount === 0">发送验证码</span>
                <span slot="suffix" class="mr10 text-primary" v-else>{{timesCount}}s</span>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loginSms('loginSmsForm')" style="width: 100%; margin-top: 30px;">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="forget">
            <router-link to="/reset">忘记密码</router-link>
            <router-link to="/register">注册新用户</router-link>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { loginForPassword, loginForSms } from '../services/api.index'
export default {
  data () {
    let checkMobile = (rule, value, callback) => {
      this.baseMethods.checkPhoneRules(value, callback)
    }
    return {
      methods: ['账号登录', '短信登录'],
      currentMethod: 0,
      loginPasswordForm: {
        account: '',
        password: ''
      },
      loginSmsForm: {
        phone: '',
        captcha: ''
      },
      loginPasswordRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loginSmsRules: {
        phone: [
          { validator: checkMobile, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      timesCount: 0
    }
  },
  methods: {
    // 密码登录
    loginPassword (formName) {
      const { account, password } = this.loginPasswordForm
      if (password.length < 6) {
        this.$message.error('密码格式有误')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loginForPassword(account, password).then(async(res) => {
            if (!res.data.code) {
              this.$message.success('登录成功')
              this.baseMethods.setLocalObj('userInfo', res.data)
              this.baseMethods.hrefUrl('/')
              localStorage.setItem('username', account)
              await this.$store.dispatch('memberInfo')
              await this.$store.dispatch('courseInfo')
            } else {
              this.toAccountStatus(res.data.code)
            }
          })
        }
      })
    },
    // 发送验证码
    getCode () {
      const { phone } = this.loginSmsForm
      this.baseMethods.sendCode(phone, 'loginSmsForm', this)
    },
    // 短信登录
    loginSms (formName) {
      const { phone, captcha } = this.loginSmsForm
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loginForSms(phone, captcha).then(async(res) => {
            if (!res.data.code) {
              this.$message.success('登录成功')
              this.baseMethods.setLocalObj('userInfo', res.data)
              localStorage.setItem('username', phone)
              this.baseMethods.hrefUrl('/')
              await this.$store.dispatch('memberInfo')
              await this.$store.dispatch('courseInfo')
            } else {
              this.toAccountStatus(res.data.code)
            }
          })
        }
      })
    },
    // 跳转到登录状态
    toAccountStatus (code) {
      let status
      switch (code) {
        case 427: // 审核中
          status = 2
          break
        case 428: // 拒绝
          status = 1
          break
        case 429: // 冻结
          status = 0
          break
      }
      localStorage.clear()
      this.$router.push(`/account_status?status=${status}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/login.vue